import { SvgIcon, SvgIconProps } from "@material-ui/core";
import React, { CSSProperties } from "react";

export function CloseIcon(props: SvgIconProps) {
  const st0: CSSProperties = {
    fill: "none",
    stroke: "currentcolor",
    strokeWidth: 2.5183,
    strokeMiterlimit: 10,
  };
  const st1: CSSProperties = {
    fill: "none",
    stroke: "currentcolor",
    strokeWidth: 5.0366,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
  };

  return (
    <SvgIcon {...props} viewBox="0 0 42 42">
      <g>
        <circle style={st0} cx="21" cy="21" r="19.61" />
        <g>
          <line style={st1} x1="13.18" y1="13.18" x2="28.82" y2="28.82" />
          <line style={st1} x1="13.18" y1="28.82" x2="28.82" y2="13.18" />
        </g>
      </g>
    </SvgIcon>
  );
}
